enum TaskImportance {
    Normal = 'Normal',
    High = 'High',
    Low = 'Low',
}
export default TaskImportance;
